<div class="page">
  <div class="content">

    @if (state === 'verifying') {
      <div class="card">
        <div class="text-content">
          <h2 class="heading">{{ 'web.paymentVerifyingHeading' | translate }}</h2>
          <p class="body">{{ 'web.paymentVerifyingBody' | translate }}</p>
        </div>
      </div>
    }

    @if (state === 'success') {
      <div class="card">
        <div class="check-wrap">
          <i class="fa-solid fa-check"></i>
        </div>
        <div class="text-content">
          <h2 class="heading">{{ 'web.paymentSuccessHeading' | translate }}</h2>
          <p class="body">{{ 'web.paymentSuccessBody' | translate }}</p>
        </div>
      </div>
    }

    @if (state === 'failed') {
      <div class="card">
        <div class="icon-container">
          <i class="fa-solid fa-xmark feedback-icon"></i>
        </div>
        <div class="text-content">
          <h2 class="heading">{{ 'web.paymentFailedHeading' | translate }}</h2>
          <p class="body">{{ 'web.paymentFailedBody' | translate }}</p>
        </div>
      </div>
    }

    @if (state === 'timeout') {
      <div class="card">
        <div class="icon-container">
          <i class="fa-solid fa-clock feedback-icon"></i>
        </div>
        <div class="text-content">
          <h2 class="heading">{{ 'web.paymentTimeoutHeading' | translate }}</h2>
          <p class="body">{{ 'web.paymentTimeoutBody' | translate }}</p>
        </div>
      </div>
    }

  </div>

  @if (state === 'timeout') {
    <div class="footer">
      <div class="footer-container">
        <button class="btn-outlined" (click)="onRetry()">
          {{ 'web.tryAgain' | translate }}
        </button>
        <button class="btn-text" (click)="onDismiss()">
          <i class="fa-solid fa-arrow-left"></i>
          {{ 'web.paymentCancelOrder' | translate }}
        </button>
      </div>
    </div>
  }

</div>
